import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/analytics/segment";
export const useTrackSegmentInViewport = (ref, eventName, options) => {
  const $ = _c(5);
  const hasTracked = useRef(false);
  let t0;
  let t1;
  if ($[0] !== eventName || $[1] !== options || $[2] !== ref) {
    t0 = () => {
      if (!ref.current) {
        return;
      }
      const observer = new window.IntersectionObserver(entries => {
        const entry = entries[0];
        if (entry.isIntersecting && !hasTracked.current) {
          trackEvent(eventName);
          hasTracked.current = true;
          observer.disconnect();
        }
      }, options);
      observer.observe(ref.current);
      return () => observer.disconnect();
    };
    t1 = [ref, eventName, options];
    $[0] = eventName;
    $[1] = options;
    $[2] = ref;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
};